import { Capacitor } from '@capacitor/core'
import { BiometricAuth } from '@aparajita/capacitor-biometric-auth'
import * as Sentry from '@sentry/vue'

const logBiometric = (...args) => {
    if (!import.meta?.env?.PROD) {
        console.log('[biometric]', ...args)
    }
}

const cancellationCodes = new Set(['userCancel', 'systemCancel', 'appCancel', 'userFallback', 'notInteractive'])

const isCancellationError = (error) => {
    const code = error?.code
    if (code && cancellationCodes.has(code)) {
        return true
    }
    const message = typeof error?.message === 'string' ? error.message.toLowerCase() : ''
    return message.includes('cancel')
}

export const isBiometricAvailable = async () => {
    if (!Capacitor.isNativePlatform()) {
        logBiometric('not native platform')
        return { available: false }
    }

    const nativePluginAvailable = Capacitor.isPluginAvailable('BiometricAuthNative')
    logBiometric('plugin available', nativePluginAvailable)

    try {
        const info = await BiometricAuth.checkBiometry()
        logBiometric('checkBiometry', info)
        return { available: Boolean(info?.isAvailable), info }
    } catch (error) {
        Sentry.captureException(error)
        logBiometric('checkBiometry failed', error?.message ?? error)
    }

    return { available: false }
}

export const verifyBiometric = async ({ reason } = {}) => {
    if (!Capacitor.isNativePlatform()) {
        logBiometric('verify skipped (not native platform)')
        return { verified: false }
    }

    try {
        logBiometric('authenticate', reason)
        await BiometricAuth.authenticate({ reason })
        logBiometric('authenticate success')
        return { verified: true }
    } catch (error) {
        if (isCancellationError(error)) {
            logBiometric('authenticate canceled', error?.code ?? '', error?.message ?? error)
            return { verified: false, canceled: true }
        }
        Sentry.captureException(error)
        logBiometric('authenticate failed', error?.code ?? '', error?.message ?? error)
        return { verified: false }
    }
}
